import { useQuery } from '@tanstack/react-query';
import apiClient from '@/lib/api/apiClient';
import { TransactionCostsResult } from '@inversor-hub/types';

const TRANSACTION_COSTS_KEY = 'transaction-costs';

export function useTransactionCosts(propertyValue: number, province: string, enabled = true) {
  return useQuery({
    queryKey: [TRANSACTION_COSTS_KEY, propertyValue, province],
    queryFn: async () => {
      const response = await apiClient.get<TransactionCostsResult>(
        `/financial-calculations/transaction-costs`,
        {
          params: {
            propertyValue,
            province,
          },
        }
      );
      return response.data;
    },
    enabled: enabled && propertyValue > 0 && !!province,
    staleTime: 5 * 60 * 1000,
  });
}
